export enum CancellationReasonType {
  Delivery = "Delivery",
  Operation = "Operation",
  Order = "OmsOrder"
}
